import { ManagerType } from "../../../types/Manager";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { MANAGERS } from "../../../utils/constants";

export const getManagers = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.IdUniversity ? { IdUniversity: data.IdUniversity } : {}),
        ...(data?.IdFaculty ? { IdFaculty: data.IdFaculty } : {}),
        ...(data?.IdDepartament ? { IdDepartament: data.IdDepartament } : {}),
        ...(data?.IdCourse ? { IdCourse: data.IdCourse } : {}),
        ...(data?.Role ? { Role: data.Role } : {}),
        ...(data?.IdUser ? { IdUser: data.IdUser } : {}),
    });
    const url = `${MANAGERS}?${queryParams.toString()}`;
    return await get<PagedResultsType<ManagerType>>(url)
};